import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFacebook,
  faTwitter,
  faLinkedin,
  faTelegram,
  faWhatsapp,
  faGetPocket
} from '@fortawesome/free-brands-svg-icons';
import {
  FacebookShareButton,
  LinkedinShareButton,
  PocketShareButton,
  TelegramShareButton,
  TwitterShareButton,
  WhatsappShareButton
} from 'react-share';
import '../css/social-share.css';

const SocialShare = ({ url, hide = {} }) => (
  <div className="text-light social-share">
    <WhatsappShareButton url={url}>
      <FontAwesomeIcon icon={faWhatsapp} />
    </WhatsappShareButton>
    <TelegramShareButton url={url}>
      <FontAwesomeIcon icon={faTelegram} />
    </TelegramShareButton>
    <TwitterShareButton url={url}>
      <FontAwesomeIcon icon={faTwitter} />
    </TwitterShareButton>
    <LinkedinShareButton url={url}>
      <FontAwesomeIcon icon={faLinkedin} />
    </LinkedinShareButton>
    <FacebookShareButton url={url}>
      <FontAwesomeIcon icon={faFacebook} />
    </FacebookShareButton>
    {!hide.pocket && (
      <PocketShareButton url={url}>
        <FontAwesomeIcon icon={faGetPocket} />
      </PocketShareButton>
    )}
  </div>
);

export default SocialShare;
